export const getStudyImageSrc = (
  isIOSMeshesStudy: boolean,
  previewPlaceholder: string,
  studyPreviewSrc?: string,
) => {
  return isIOSMeshesStudy
    ? previewPlaceholder
    : studyPreviewSrc || previewPlaceholder;
};
